<template>
  <div class="app-main-content">
    <div class="app-main-inner-row" style="padding-top: 0; width: 1200px; height: 500px; background-color: #ffffff">
      <el-form :label-width="$selectByLang('90px', '110px')" style="width:400px" label-position="left">
        <div class="el-form-item-wrapper">
          <el-form-item :label="$t('Invoice.invoice_invoicingMethod')">
            <span style="font-size: 14px;">{{ invoicingMethod }}</span>
          </el-form-item>
          <el-form-item>
            <line-label slot="label" :label="isCollectInvoice ? $t('Invoice.invoice_CollectInvoiceType') : $t('Invoice.invoice_invoicingType')" />
            <el-radio-group v-model="properties.typeGroup" no="typeGroup" class="custom-radio-group">
              <el-radio label="multi" :disabled="properties.isHedge">{{ isCollectInvoice ? $t('Invoice.invoice_consolidatedInvoiceCollect') : $t('Invoice.invoice_consolidatedInvoice') }}</el-radio>
              <el-radio label="settlementAgent" :disabled="properties.isHedge || properties.toExoSystemHC">{{ isCollectInvoice ? $t('Invoice.invoice_invoicingAccordingToSettlementAgentCollect') : $t('Invoice.invoice_invoicingAccordingToSettlementAgent') }}</el-radio>
              <el-radio label="job" :disabled="properties.isHedge || properties.toExoSystemHC">{{ isCollectInvoice ? $t('Invoice.invoice_invoicingAccordingToBusinessCollect') : $t('Invoice.invoice_invoicingAccordingToBusiness') }}</el-radio>
              <el-radio label="single" :disabled="properties.isHedge || (properties.toExoSystemHC && !properties.isAr)">{{ isCollectInvoice ? $t('Invoice.invoice_invoicingAccordingToRecordsCollect') : $t('Invoice.invoice_invoicingAccordingToRecords') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('Invoice.invoice_makeType')">
            <el-radio-group v-model="properties.groupingMakeType" no="groupingMakeType" @change="changeInvoiceType">
              <el-radio :label="0" :disabled="(properties.invoiceType===6 || properties.invoiceType===7 || properties.isEasyInoivceVietnam)">{{ $t('Invoice.invoice_makePaper') }}</el-radio>
              <el-radio :label="1" :disabled="properties.invoiceType!==2 && properties.invoiceType!==3">{{ $t('Invoice.invoice_makeElectronic') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('Invoice.invoice_invoiceType')">
            <el-select v-model="properties.invoiceType" no="invoiceType" style="width:175px;" @change="invoiceTypeChange">
              <el-option
                v-for="item in (isFei ? InvoiceConstant.INVOICE_TYPES_FEI : InvoiceConstant.INVOICE_TYPES)"
                :key="item.code"
                :label="$store.getters.language === 'zh'?item.chineseName:item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-if="(properties.invoiceType===6 || properties.invoiceType===7)" :label="$t('Invoice.SpecificConstraintTypes')">
            <el-select v-model="properties.specificConstraintType" :disabled="restrictionHC" style="width:175px;">
              <el-option
                v-for="item in InvoiceConstant.SPECIFIC_CONSTRAINT_TYPES"
                :key="item.code"
                :label="$store.getters.language === 'zh'?item.chineseName:item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <line-label slot="label" :label="isCollectInvoice ? $t('Invoice.invoice_invoicingAccordingToCurrencyCollect') : $t('Invoice.invoice_invoicingAccordingToCurrency')" />
            <el-radio-group v-model="properties.currencyGroup" no="currencyGroup">
              <div class="inlineWarp" style="margin-bottom: 10px;">
                <el-radio no="invoicingPerCurrency" :label="0">{{ isCollectInvoice ? $t('Invoice.invoice_invoicingPerCurrencyCollect') : $t('Invoice.invoice_invoicingPerCurrency') }}</el-radio>
                <el-checkbox v-model="properties.cbAssignCurrency" :disabled="properties.currencyGroup===1" no="cbAssignCurrency">{{ $t('Invoice.invoice_specifyInvoiceCurrency') }}</el-checkbox>
              </div>
              <el-radio v-if="!properties.settlementCenterMode" no="consolidatedCurrency" :label="1" :disabled="properties.isEasyInoivceVietnam">{{ $t('Invoice.invoice_consolidatedCurrency') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <line-label slot="label" :label="isCollectInvoice ? $t('Invoice.invoice_invoicingCurrencyCollect') : $t('Invoice.invoice_invoicingCurrency')" />
            <cargo-advance-select
              no="currency"
              filterable
              :select-type="TYPE_NAMES.basic_data_Currency"
              :default-value="properties.currency"
              style="width:175px;"
              :clearable="false"
              :disabled="(properties.allowModifyCurrency === false) || !((properties.currencyGroup === 0 && properties.cbAssignCurrency) || properties.currencyGroup === 1)"
              @parentCallBack="currencyChangeEvent"
            />
          </el-form-item>
          <el-form-item>
            <line-label slot="label" :label="$t('Invoice.invoice_settleDepartmentPrefix')" />
            <cargo-department-select
              no="settleDepartment"
              :office-id="Number($store.getters.currentOfficeId)"
              :department-id="Number(properties.settleDepartment)"
              style="width:175px;"
              @change="settleDepartmentChangeEvent"
            />
          </el-form-item>
          <el-form-item v-show="$checkPermission(['button_ACInvoice_autoCheckInvoicing'])" label-width="0">
            <div style="display: flex">
              <span>{{ $t('Invoice.UseAutoCheckInvoicing') }}</span>
              <div style="padding-left: 10px;">
                <el-radio v-model="properties.useAutoCheckInvoicing" no="yes" :label="true">{{ $t('CargoMsg.Cargo_Yes') }}</el-radio>
                <el-radio v-model="properties.useAutoCheckInvoicing" no="no" :label="false" :disabled="properties.autoCheckInvoiceAmountEnable">{{ $t('CargoMsg.Cargo_No') }}</el-radio>
              </div>
            </div>
          </el-form-item>
          <el-form-item v-show="properties.useAutoCheckInvoicing && $checkPermission(['button_ACInvoice_autoCheckInvoicing'])" label-width="0">
            <div style="display: flex">
              <span>{{ $t('Invoice.DefaultInvoicingAmount') }}</span>
              <el-input-number
                v-model="properties.autoCheckInvoicingAmount"
                no="autoCheckInvoicingAmount"
                style="padding-left: 10px;"
                :disabled="properties.autoCheckInvoiceAmountEnable"
                :controls="false"
                :min="0"
                :precision="2"
              />
            </div>
          </el-form-item>
          <el-form-item v-show="properties.isAr" label-width="0">
            <el-checkbox v-model="properties.showChargeDetail" no="showChargeDetail" :disabled="!properties.showChargeDetailByInvoice">{{ $t('Invoice.invoice_showChargeDetails') }}</el-checkbox>
            <el-checkbox v-if="properties.isEasyInoivceVietnam" v-model="properties.isInvoicingByTaxRate" no="isInvoicingByTaxRate">{{ $t('CargoMsg.Cargo_InvoicingByTaxRate') }}</el-checkbox>
          </el-form-item>
          <el-form-item label-width="0">
            <el-checkbox v-model="properties.useDefaultRate" no="useDefaultRate">{{ isCollectInvoice ? $t('Invoice.invoice_invoicingAccordingToFinancialExchangeRateCollect') : $t('Invoice.invoice_invoicingAccordingToFinancialExchangeRate') }}</el-checkbox>
            <el-checkbox v-model="properties.isInvoicingByBillingRate" no="isInvoicingByBillingRate" :disabled="!invoicingByBillingRate">{{ isCollectInvoice ? $t('Invoice.invoice_invoicingAccordingByBillingExchangeRateCollect') : $t('Invoice.invoice_invoicingAccordingByBillingExchangeRate') }}</el-checkbox>
          </el-form-item>
          <el-form-item v-show="properties.isAr" label-width="0">
            <el-checkbox v-model="properties.makeCostInvoice" no="makeCostInvoice" :disabled="properties.isEasyInoivceVietnam">{{ $t('Invoice.invoice_generateCostInvoice') }}</el-checkbox>
            <el-checkbox v-if="properties.isBillPreInvoicing && properties.makeInvoiceMethod === 3" v-model="properties.billPreInvoicing" no="billPreInvoicing">{{ $t('CargoMsg.Cargo_billingTip') }}</el-checkbox>
          </el-form-item>
          <el-form-item v-show="!properties.isAr" label-width="0">
            <el-checkbox v-model="properties.isInvoicingByBusinessDateRate" no="isInvoicingByBusinessDateRate" :disabled="invoicingByBusinessDateEnable">{{ isCollectInvoice ? $t('Invoice.InvoicingByBusinessDateExchangeRateCollect') : $t('Invoice.InvoicingByBusinessDateExchangeRate') }}</el-checkbox>
          </el-form-item>
        </div>
      </el-form>
      <div style="width: 640px;">
        <div class="app-main-inner-row">
          <span style="font-size: 14px;">{{ $t('CargoMsg.Cargo_InvoiceItemNameSetup') }}</span>
        </div>
        <div class="app-main-inner-row">
          <div class="triggers">
            <el-button type="primary" no="toAdd" @click="toAdd">{{ $t('common.btn.new') }}</el-button>
            <el-button type="primary" no="toEdit" :disabled="isEditing" @click="toEdit">{{ $t('common.btn.edit') }}</el-button>
            <el-button type="danger" no="toDelete" :disabled="isEditing" @click="toDelete">{{ $t('common.btn.delete') }}</el-button>
            <el-button type="primary" no="doDefaultSetting" :disabled="isEditing" :style="$selectByLang('', 'margin-top: 5px;')" @click="doDefaultSetting">{{ $t('CargoMsg.Cargo_SetDefaultItemDescription') }}</el-button>
            <el-button type="primary" no="needSave" :disabled="!needSave" @click="toSave">{{ $t('common.btn.save') }}</el-button>
            <el-dropdown
              v-if="properties.isEasyInoivceVietnam"
              split-button
              type="primary"
              style="padding-left: 5px;"
              @click="btnSetupHandler()"
              @command="p=>{commandCode=p;btnSetupHandler()}"
            >
              {{ commandCode }}
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="$t('CargoMsg.Cargo_InvoiceChargeItemSetup')" no="invoiceChargeItemSetup">{{ $t('CargoMsg.Cargo_InvoiceChargeItemSetup') }}</el-dropdown-item>
                <el-dropdown-item :command="$t('CargoMsg.Cargo_InvoiceChargeUnitSetup')" no="invoiceChargeUnitSetup">{{ $t('CargoMsg.Cargo_InvoiceChargeUnitSetup') }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div class="app-main-inner-row row-grid" style="height: 260px;padding-left: 10px;padding-right: 6px;">
          <cargo-ag-grid
            config-module="20220416"
            :grid-params.sync="invoiceGoodsName.gridParams"
            :grid-options="invoiceGoodsName.gridOptions"
            :column-defs="invoiceGoodsNameColumnDefs"
            :row-data="invoiceGoodsNameRowData"
            style="width: 100%;flex:1"
            @gridReady="params=>gridApi=params.api"
          />
        </div>
        <span style="color: red;padding-left: 10px;padding-right: 6px;">{{ $t('CargoMsg.Cargo_TaxRevenueToolTip') }}</span>
        <el-form style="width:400px" label-width="80px" label-position="right">
          <div style="display: flex">
            <el-form-item :label="$t('CargoMsg.Cargo_Payee')">
              <el-input v-model="properties.payee" no="payee" style="width: 100px;" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_Recheck')">
              <el-input v-model="properties.auditor" no="auditor" style="width: 100px;" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_InvoicedBy')">
              <cargo-user-select
                no="autoInputBy"
                :method-params="{officeId:$store.getters.currentOfficeId}"
                :default-value="properties.autoInputBy||''"
                style="width: 100px;"
                @change="p=>{properties.autoInputBy=p.value}"
              />
            </el-form-item>
          </div>
          <div style="padding-left: 10px">
            <el-checkbox v-model="applyRuleToAll" no="applyRuleToAll" @change="applyRuleToAllChangeHandler">{{ $t('CargoMsg.Cargo_ApplyRuleToAllScenarios') }}</el-checkbox>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>

import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect.vue'
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect.vue'
import * as InvoiceConstant from '@/class/cargo/model/parameters/InvoiceConstant'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import { getGridSelected } from '@/utils/agGrid'
import StrUtils from '@/utils/StrUtils'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import * as NumberUtils from '@/utils/NumberUtils'
import { getLoading } from '@/utils/utilBaseElement'
import { deleteInvoiceGoodsName, queryInvoiceGoodsName, saveInvoiceGoodsName } from '@/api/clearing/invoiceGoodsName'
import ColumnUtils from '@/utils/ColumnUtils'
import { cache, cacheName } from '@/utils/cacheManager'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect.vue'

export default {
  name: 'RuleSettings',
  components: { cargoUserSelect, cargoDepartmentSelect, CargoAdvanceSelect },
  props: {},
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      applyRuleToAll: true,
      properties: {
        // mode: 0, // 弹窗模式[default:0] 0-开票模式  1-对冲开票模式
        isHedge: false, // 是否对冲
        isAr: true, // 是否应收

        makeInvoiceMethod: 1, // 开票方式: 1=费用、2=业务、3=账单、4=对账单
        makeInvoiceMethodHedge: 1, // 开票方式: 1=费用、2=业务、3=账单、4=对账单

        typeGroup: 'multi', // 开票类型：multi=合并开票、job=按业务开票、single=按记录开票、settlementAgent=按结算代理开票
        invoiceType: 0, // 发票类型：0=普通发票、1=专用发票、2=增值税普通发票、3=增值税专用发票、4=内部发票
        groupingMakeType: 0, // 发票种类：0=纸质发票、1=电子发票

        currencyGroup: 0, // 分币种开票：0=拆分币种开票、1=合并币种
        cbAssignCurrency: true, // 指定发票币种
        groupingCurrencyType: 0, // currencyGroup + cbAssignCurrency: 0=合并币种、1=拆分币种+指定发票币种、2=拆分币种+非指定发票币种
        currency: 'RMB', // 币种
        allowModifyCurrency: true, // 是否允许修改币种（静默透传）

        showChargeDetail: false, // 是否显示费用明细
        useDefaultRate: false, // 按财务汇率开票
        isInvoicingByBillingRate: false, // 按账单汇率
        billingRateMap: {}, // 账单币种、账单汇率
        makeCostInvoice: false, // 生成成本发票
        billPreInvoicing: false, // 根据账单开票要求开票
        isGenCostInvoice: false, // 是否生成成本发票: isAr ? makeCostInvoice : false
        costInvoiceProp: {},
        defaultContent: false, // 将本次内容设置为默认开票信息

        invoiceGoodsName: {}, // 发票项目名称
        settleDepartment: 0, // 结算部门
        settleDepartmentPrefix: '', // 结算部门归属工作号

        otherCurrencys: [], // 其它币种
        otherRates: [], // 其它币种汇率
        txtCurrency1: '',
        txtRate1: '',
        txtCurrency2: '',
        txtRate2: '',
        rateCache: {}, // 对比发票币种的汇率
        cbAlwarysUseRate: false, // 一直按该汇率开票

        branchId: this.$store.getters.currentOfficeId, // 分公司 Session.getInstance().getOfficeId()
        inputByDep: this.$store.getters.currentDeptId, // 部门 Session.getInstance().currentDepartment.departmentId

        titleMap: {}, // 获取账单所对应的结算单位: getTitleMap()
        invoiceByType: '', // 确认是否应当添加账单中的开票需求: getClassType(entities)
        hedgeInvoiceByType: '', // 确认是否应当添加账单中的开票需求: getClassType(hedgeEntities)

        selectedEntities: [], // 已经选中的实体
        selectedEntitiesHedge: [], // 已经选中的对冲实体
        entities: [], // 开票实体
        hedgeEntities: [], // 对冲实体
        allEntities: [], // 所有实体
        allCharges: [],
        chargeMap: {},
        invoices: [], // 生成发票列表
        invoice: {}, // 当前发票
        currentPage: 1, // 顺序号
        totalPage: 0, // 发票总数
        invoiceGoodsNameList: [], // 发票项目名称列表
        invoiceItemGoodsName: 0, // InvoiceItemGoodsName：开票发票项目默认货物或应税劳务名称
        defaultGoodsName: '', // InvoiceMergeName：合并开票费用名称
        receivedRadio: 'ALL', // 对冲开票，应收列表币种：全部/RMB/USD
        paymentRadio: 'ALL', // 对冲开票，应付列表币种：全部/RMB/USD
        showChargeDetailByInvoice: true, // ShowChargeDetailByInvoice：增值发票是否可以显示明细
        invoiceNoEditable: false, // InvoiceSearchEdit: 开票查询修改发票号
        costInfo: false, // costSplitInfo: 是否开启费用拆分金额校验
        useAutoCheckInvoicing: false, // 是否使用了自动勾选开票
        autoCheckInvoiceAmountEnable: false, // 是否使用自动勾选开票
        autoCheckInvoicingAmount: 0.00, // 自动勾选开票预设金额
        isInvoiceByEachBillingRate: false, // isInvoiceByEachBillingRate：是否按各自账单汇率来开票
        specificConstraintType: '', // 特定约束类型
        isInvoicingByTaxRate: false, // 按税点分组开票
        payee: '', // 收款人
        auditor: '', // 审核人
        autoInputBy: 0,
        rbgShowChargeDetail: '' // 显示明细
      },
      innerVisible: false,
      searchConditions: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      makeInvoiceForm: {
        makeInvoiceType: 1,
        invoiceType: 1
      },
      invoiceGoodsName: {
        rowData: [],
        gridParams: {},
        gridOptions: {
          rowHeight: 30,
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          context: {
            componentParent: this
          },
          defaultColDef: {
            filter: false
          }
        }
      },
      gridApi: null,
      isEditing: false, // 是否编辑
      needSave: false, // 是否需要保存
      maintainDialog: {
        show: false,
        isEdit: false,
        title: this.$t('Clearing.Add'),
        maintainForm: {
        }
      },
      makeInvoiceStepTwoDialog: {
        visible: false,
        title: this.$t('Clearing.Add'),
        params: {}
      },
      isFei: true, // 是否支持全电
      isNuoNuo: false, // 是否诺诺全电
      commandCode: this.$t('CargoMsg.Cargo_InvoiceChargeItemSetup'),
      restrictionHC: false, // 9 税率时，禁止修改 发票类型，发票类型
      invoiceChargeItemDialog: {
        visible: false
      },
      invoiceChargeUnitDialog: {
        visible: false
      }
    }
  },
  computed: {
    // 开票方式描述
    invoicingMethod() {
      if (this.properties.isAr) {
        return this.$t('Invoice.invoice_receivablesInvoicing')
      } else {
        return this.isCollectInvoice ? this.$t('Invoice.invoice_payablesCollectInvoice') : this.$t('Invoice.invoice_payablesInvoicing')
      }
    },
    // 发票类型
    InvoiceConstant() {
      return InvoiceConstant
    },
    // 基础数据
    TYPE_NAMES() {
      return TYPE_NAMES
    },
    // 发票项目名称列表
    invoiceGoodsNameRowData() {
      let invoiceGoodsNameList = this.properties.invoiceGoodsNameList
      if (!invoiceGoodsNameList || invoiceGoodsNameList.length === 0) {
        invoiceGoodsNameList = []
      } else {
        invoiceGoodsNameList = invoiceGoodsNameList.filter(p => p.invoiceType === this.properties.invoiceType)
      }
      return invoiceGoodsNameList
    },
    // 勾选按账单汇率
    invoicingByBillingRate() {
      // 发票与账单币种相同
      if (this.properties.billingRateMap.currency && this.properties.billingRateMap.currency === this.properties.currency) {
        return true
      } else {
        this.changeInvoicingByBillingRate()
        return false
      }
    },
    // 按业务日期汇率收票
    invoicingByBusinessDateEnable() {
      return !this.properties.isAr && (this.properties.makeInvoiceMethod === 3 || this.properties.makeInvoiceMethod === 4 || this.properties.makeInvoiceMethod === 5)
    },
    // 是否收票，收票需要更改国际化【仅处理-按费用、按业务、按账单、按对账单】
    isCollectInvoice() {
      return !this.properties.isAr && (this.properties.makeInvoiceMethod === 1 || this.properties.makeInvoiceMethod === 2 || this.properties.makeInvoiceMethod === 3 || this.properties.makeInvoiceMethod === 4)
    },
    // 发票项目名称设置显示列
    invoiceGoodsNameColumnDefs() {
      return [
        { headerName: this.$t('Invoice.invoice_invoiceType'), field: 'invoiceType', width: 160,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEditing,
            tag: 'el-select',
            options: this.isFei ? InvoiceConstant.INVOICE_TYPES_FEI : InvoiceConstant.INVOICE_TYPES,
            optionField: {
              labelFunc: item => {
                return this.$store.getters.language === 'zh' ? item.chineseName : item.englishName
              },
              value: 'code'
            },
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_TaxRevenueShortName'), field: 'taxRevenueShortName', width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEditing,
            tag: 'el-input',
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_TaxRevenueName'), field: 'taxRevenueName', width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEditing,
            tag: 'el-input',
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_DescriptionOfExpenseItemCNY'), field: 'goodsNameRMB', width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEditing,
            tag: 'el-input',
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_DescriptionOfExpenseItemUSD'), field: 'goodsNameUSD', width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEditing,
            tag: 'el-input',
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_DescriptionOfExpenseItemJPY'), field: 'goodsNameJPY', width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEditing,
            tag: 'el-input',
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_DescriptionOfExpenseItemEUR'), field: 'goodsNameEUR', width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEditing,
            tag: 'el-input',
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        { headerName: this.$t('Invoice.billingJob_taxRate'), field: 'taxRate', width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEditing,
            tag: 'el-select',
            options: this.isNuoNuo ? InvoiceConstant.INVOICE_GOODS_NAME_TAX_RATE : InvoiceConstant.INVOICE_GOODSNAME_TAX_RATE,
            optionField: {
              labelFunc: item => {
                return item.chineseName
              },
              value: 'code'
            },
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DefaultDetailItems'), field: 'defaultDetails', initialWidth: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEditing,
            tag: this.isEditing ? 'el-checkbox' : 'span',
            attrs: {
              isEditCBFunc: (params) => {
                return this.isEditing
              }, textConverter: (val) => {
                return val ? '√' : ''
              }
            },
            valueChanged: p => {
              this.onCellChange(p)
            }
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_SetDefaultItemName'), field: 'defaultGoodsName', width: 140,
          cellRenderer: params => {
            return params.value ? '√' : ''
          }
        }
      ]
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    await this.initConfig()
  },
  methods: {
    async onShow(action, from, task) {
      this.applyRuleToAll = from.applyRuleToAll
      this.properties.makeInvoiceMethod = from.dataType
      this.properties.branchId = this.$store.getters.currentOfficeId // 分公司
      this.properties.inputByDep = this.$store.getters.currentDeptId // 部门
      // 重置
      this.initMakeInvoice()
      this.initEntities()
      if (task && task.propertiesData && Object.keys(task.propertiesData).length) {
        this.loadProperties(task.propertiesData)
      }
    },
    async initConfig() {
      this.properties.invoiceItemGoodsName = Number(cache.config.get('InvoiceItemGoodsName'))
      this.properties.defaultGoodsName = String(cache.config.get('InvoiceMergeName'))
      this.properties.showChargeDetailByInvoice = String(cache.config.get('ShowChargeDetailByInvoice')) === '1'
      this.properties.invoiceNoEditable = String(cache.config.get('InvoiceSearchEdit')) === '1'
      this.properties.costInfo = Number(cache.config.get('costSplitInfo')) === 1
      this.properties.enableCustomizeRevokeInvoice = Number(cache.config.get('enableCustomizeRevokeInvoice')) === 1
      this.properties.interfaceName = String(cache.config.get('TaxControlInterfaceName'))
      this.properties.interfaceNameEI = String(cache.config.get('EITaxControlInterfaceName'))
      this.properties.terminalSn = String(cache.config.get('baiWangOriginTerminalSN'))
      this.properties.storageURL = String(cache.config.get('StorageURL'))
      this.properties.isInvoiceByEachBillingRate = Number(cache.config.get('isInvoiceByEachBillingRate')) === 1
      this.properties.toExoSystemYGSH = String(cache.config.get('ToExoSystem')) === 'YGSH' // 阳光速航
      this.properties.toExoSystemHC = String(cache.config.get('ToExoSystem')) === 'HC' // 海创
      this.properties.QdWarning = String(cache.config.get('QdWarning')) !== '0' // 全电接口-国税应急方案
      this.properties.FeiByAuth = Number(cache.config.get('FeiByAuth')) === 1 // 全电接口是否走实人认证
      this.properties.settlementCenterMode = String(cache.config.get('SettlementCenterMode')) === '1' // 锦昶共享中心
      this.properties.isEasyInoivceVietnam = this.properties.interfaceNameEI === InvoiceConstant.INVOICE_EASY_INOIVCE_VIETNAM // 杰贝越南税控
      this.properties.isBillPreInvoicing = String(cache.config.get('BillingNoteContainInvoiceReques')) // 太平账单预开发票
    },
    async initEntities() {
      this.properties.entities = []
      this.properties.allEntities = []
      this.properties.allEntities.push(...this.properties.entities)
      this.properties.allEntities.push(...this.properties.hedgeEntities)
      this.toQueryInvoiceGoodsName()
    },
    // 发票项目名称列表
    toQueryInvoiceGoodsName() {
      this.properties.invoiceGoodsNameList = []
      const requestBody = { 'officeId': this.$store.getters.currentOfficeId }
      this.loading = getLoading()
      queryInvoiceGoodsName(requestBody).then(res => {
        this.properties.invoiceGoodsNameList = res.data
      }).finally(() => {
        this.loading.close()
      })
    },
    // 重置开票相关
    initMakeInvoice() {
      this.properties.isHedge = false
      this.properties.typeGroup = 'multi' // 开票类型：multi=合并开票、job=按业务开票、single=按记录开票、settlementAgent=按结算代理开票
      this.properties.invoiceType = 2 // 发票类型：0=普通发票、1=专用发票、2=增值税普通发票、3=增值税专用发票、4=内部发票
      this.properties.groupingMakeType = 1 // 发票种类：0=纸质发票、1=电子发票
      this.properties.currencyGroup = 0 // 分币种开票：0=拆分币种开票、1=合并币种
      this.properties.cbAssignCurrency = true // 指定发票币种
      this.properties.groupingCurrencyType = 0 // currencyGroup + cbAssignCurrency: 0=合并币种、1=拆分币种+指定发票币种、2=拆分币种+非指定发票币种
      this.properties.currency = 'RMB' // 币种（固定默认RMB）
      this.properties.allowModifyCurrency = true // 默认允许修改；如后端/配置透传为false则锁定
      this.properties.showChargeDetail = false // 是否显示费用明细
      this.properties.useDefaultRate = false // 按财务汇率开票
      this.properties.isInvoicingByBillingRate = false // 按账单汇率
      this.properties.billingRateMap = {} // 账单币种、账单汇率
      this.properties.makeCostInvoice = false // 生成成本发票
      this.properties.isGenCostInvoice = false // 是否生成成本发票: isAr ? makeCostInvoice : false
      this.properties.costInvoiceProp = {}
      this.properties.defaultContent = false // 将本次内容设置为默认开票信息
      this.properties.invoiceGoodsName = {} // 发票项目名称
      this.properties.settleDepartment = 0 // 结算部门
      this.properties.settleDepartmentPrefix = '' // 结算部门归属工作号
      this.properties.otherCurrencys = [] // 其它币种
      this.properties.otherRates = [] // 其它币种汇率
      this.properties.txtCurrency1 = ''
      this.properties.txtRate1 = ''
      this.properties.txtCurrency2 = ''
      this.properties.txtRate2 = ''
      this.properties.payee = '' // 收款人
      this.properties.auditor = '' // 审核人
      this.properties.autoInputBy = 0
      this.properties.rateCache = {} // 对比发票币种的汇率
      this.properties.cbAlwarysUseRate = false // 一直按该汇率开票
      this.properties.isInvoicingByBusinessDateRate = false // 按业务日期汇率收票
      this.properties.isInvoicingByTaxRate = false // 按税点分组开票
      // 默认开票信息
      if (LocalStorageUtilsNew.hasConfiguration('invoceFormPage_' + this.properties.isAr)) {
        const item = LocalStorageUtilsNew.getConfiguration('invoceFormPage_' + this.properties.isAr)
        console.log('invoceFormPage_' + this.properties.isAr, item)
        this.properties.typeGroup = item.typeGroup
        this.properties.invoiceType = item.invoiceType
        this.properties.currency = item.currency
        this.properties.showChargeDetail = item.showChargeDetail
        this.properties.groupingCurrencyType = item.groupingCurrencyType
        this.properties.groupingMakeType = item.groupingMakeType
        this.properties.useDefaultRate = item.useDefaultRate
        this.properties.makeCostInvoice = item.makeCostInvoice
        this.properties.billPreInvoicing = item.billPreInvoicing
        if (this.properties.groupingCurrencyType === 0) {
          this.properties.currencyGroup = 1
          this.properties.cbAssignCurrency = true
        } else if (this.properties.groupingCurrencyType === 1) {
          this.properties.currencyGroup = 0
          this.properties.cbAssignCurrency = true
        } else if (this.properties.groupingCurrencyType === 2) {
          this.properties.currencyGroup = 0
          this.properties.cbAssignCurrency = false
        }
      }
      this.properties.makeCostInvoice = cache.config.get('ToExoSystem') === 'BSYX' ? true : this.properties.makeCostInvoice
      this.properties.autoCheckInvoiceAmountEnable = false
      this.properties.autoCheckInvoicingAmount = this.properties.groupingMakeType === 1 ? Number(cache.config.get('E-InvoiceMaxAmount')) : Number(cache.config.get('InvoiceMaxAmount'))
    },
    loadProperties(item) {
      this.properties.typeGroup = item.typeGroup
      this.properties.invoiceType = item.invoiceType
      this.properties.allowModifyCurrency = item.hasOwnProperty('allowModifyCurrency') ? item.allowModifyCurrency : true
      this.properties.currency = item.currency
      this.properties.showChargeDetail = item.showChargeDetail
      this.properties.groupingCurrencyType = item.groupingCurrencyType
      this.properties.groupingMakeType = item.groupingMakeType
      this.properties.useDefaultRate = item.useDefaultRate
      this.properties.makeCostInvoice = item.makeCostInvoice
      this.properties.billPreInvoicing = item.billPreInvoicing
      if (this.properties.groupingCurrencyType === 0) {
        this.properties.currencyGroup = 1
        this.properties.cbAssignCurrency = true
      } else if (this.properties.groupingCurrencyType === 1) {
        this.properties.currencyGroup = 0
        this.properties.cbAssignCurrency = true
      } else if (this.properties.groupingCurrencyType === 2) {
        this.properties.currencyGroup = 0
        this.properties.cbAssignCurrency = false
      }
      this.properties.autoCheckInvoicingAmount = item.autoCheckInvoicingAmount //
      this.properties.settleDepartment = item.settleDepartment // 结算部门
      this.properties.settleDepartmentPrefix = item.settleDepartmentPrefix // 结算部门归属工作号
      this.properties.payee = item.payee // 收款人
      this.properties.auditor = item.auditor // 审核人
      this.properties.autoInputBy = item.autoInputBy
      if (this.properties.allowModifyCurrency === false) {
        this.properties.currency = 'RMB'
        this.properties.isInvoicingByBillingRate = false
      }
    },
    async toNext() {
      // CARGO-12794  成本收票要默认按业务日期汇率收票
      if (this.properties.isInvoicingByBusinessDateRate && !this.properties.isAr && (this.properties.makeInvoiceMethod === 1 || this.properties.makeInvoiceMethod === 2) && this.properties.allEntities) {
        let month = 0
        for (const charge of this.properties.allEntities) {
          let businessDate = charge.jobBusinessDate
          if (typeof businessDate === 'string') {
            businessDate = new Date(businessDate.replace(/-/g, '/'))
          }
          const inputMonth = businessDate.getMonth() + 1
          if (month === 0) {
            month = inputMonth
          } else {
            if (month !== inputMonth) {
              this.$message.warning(this.$t('Invoice.InvoicingByBusinessDateExchangeRateTips'))
              return
            }
          }
        }
      }
      // groupingCurrencyType: currencyGroup + cbAssignCurrency: 0=合并币种、1=拆分币种+指定发票币种、2=拆分币种+非指定发票币种
      if (this.properties.currencyGroup === 1) {
        this.properties.groupingCurrencyType = 0
      } else {
        if (this.properties.cbAssignCurrency) {
          this.properties.groupingCurrencyType = 1
        } else {
          this.properties.groupingCurrencyType = 2
        }
      }
      // isGenCostInvoice: 是否生成成本发票: isAr ? makeCostInvoice : false
      if (this.properties.isAr) {
        this.properties.isGenCostInvoice = this.properties.makeCostInvoice
      } else {
        this.properties.isGenCostInvoice = false
      }
      //
      this.properties.invoiceGoodsName = this.getInvoiceGoodsName()
      if (LocalStorageUtilsNew.hasConfiguration('alwaysUseCacheRate')) {
        this.properties.cbAlwarysUseRate = Boolean(LocalStorageUtilsNew.getConfiguration('alwaysUseCacheRate'))
      }
      // 重置
      if (this.properties.isHedge) {
        this.properties.receivedRadio = 'ALL'
        this.properties.paymentRadio = 'ALL'
      }
      //
      await this.checkState()

      this.$emit('ruleSettingChange', { ... this.properties, applyRuleToAll: this.applyRuleToAll })
    },
    // 发票项目名称
    getInvoiceGoodsName() {
      if (this.properties.invoiceGoodsNameList.length === 0) return {}
      const rowDataSelected = getGridSelected(this.invoiceGoodsName.gridOptions)
      const selectedItem = rowDataSelected.length > 0 ? rowDataSelected[0] : null
      console.log('getInvoiceGoodsName', selectedItem)
      // CARGO-8602，当左侧发票类型与右侧选中的发票类型不一致时
      if (selectedItem === null || selectedItem.invoiceType !== this.properties.invoiceType) {
        // CARGO-37694 14552-招通供应链 发票费用项目名称，无法覆盖多币种合并开票代出费用项目名称
        // for (const item of this.properties.invoiceGoodsNameList) {
        //   if (item.defaultGoodsName && !StrUtils.isEmpty(item.uuid) && item.invoiceType === this.properties.invoiceType) {
        //     return item
        //   }
        // }
        // return {}
        let rightItem = null
        const itemArr = []
        const isRmb = this.properties.currency === 'RMB'
        const isUsd = this.properties.currency === 'USD'
        const isJpy = this.properties.currency === 'JPY'
        for (const item of this.properties.invoiceGoodsNameList) {
          if (!StrUtils.isEmpty(item.uuid) && item.invoiceType === this.properties.invoiceType) {
            if ((isRmb && item.goodsNameRMB) || (isUsd && item.goodsNameUSD) || (isJpy && item.goodsNameJPY)) {
              if (item.defaultGoodsName) {
                rightItem = item
                break
              }
              itemArr.push(item)
            }
          }
        }
        // 未取到默认的，则随机取一个满足条件的
        if (!rightItem && itemArr.length > 0) {
          rightItem = itemArr[0]
        }
        return rightItem || {}
      } else {
        return selectedItem
      }
    },
    // InvoiceChargePage.checkState
    async checkState() {
      this.properties.otherCurrencys = []
      this.properties.otherRates = []
      this.properties.rateCache = {}
      console.log('checkState:', this.properties.allEntities)
      // 开票方式: 1=费用、2=业务、3=账单、4=对账单、5=付款申请单
      const makeInvoiceMethod = this.properties.makeInvoiceMethod
      // 记录每笔账单/对账单/付款申请单的开票总金额(开票方式为账单/对账单/付款申请单，向上汇总开票金额)
      const invoiceAmountMap = new Map()
      if (makeInvoiceMethod === 1 || makeInvoiceMethod === 2 || makeInvoiceMethod === 3 || makeInvoiceMethod === 4 || makeInvoiceMethod === 5) {
        for (const charge of this.properties.allEntities) {
          if (charge.currency !== this.properties.currency) {
            const cacheKey = 'InvoiceRate-' + charge.currency + '-' + this.properties.currency + '-' + (this.properties.isAr ? 1 : 0)
            if (!this.properties.rateCache[charge.currency] && this.properties.cbAlwarysUseRate && LocalStorageUtilsNew.hasConfiguration(cacheKey) && !this.properties.isInvoicingByBillingRate) {
              this.properties.rateCache[charge.currency] = LocalStorageUtilsNew.getConfiguration(cacheKey)
            } else if (!this.properties.rateCache[charge.currency]) {
              // CARGO-882，账单汇率相同时，支持选择按账单汇率开票
              if (this.properties.isInvoicingByBillingRate) {
                if (this.properties.billingRateMap[charge.currency]) {
                  this.properties.rateCache[charge.currency] = this.properties.billingRateMap[charge.currency]
                } else {
                  this.properties.rateCache[charge.currency] = await RateUtil.getForeignExchangeRateSafely(this.properties.currency, charge.currency, new Date(), 0)
                }
              } else if (this.properties.isInvoicingByBusinessDateRate) { // 按业务日期汇率收票
                this.properties.rateCache[charge.currency] = await RateUtil.getForeignExchangeRateSafely(this.properties.currency, charge.currency, charge.jobBusinessDate, 0, 12, false)
              } else {
                this.properties.rateCache[charge.currency] = await RateUtil.getForeignExchangeRateSafely(this.properties.currency, charge.currency, new Date(), 0)
              }
              // this.properties.rateCache[charge.currency] = await RateUtil.getForeignExchangeRateSafely(this.properties.currency, charge.currency, new Date())
            }
            if (makeInvoiceMethod === 3 && this.properties.isInvoicingByBillingRate && this.properties.isInvoiceByEachBillingRate && this.properties.billingRateMap2[charge.currency + charge.billingUuid]) {
              charge.invoiceRate = this.properties.billingRateMap2[charge.currency + charge.billingUuid]
            } else {
              charge.invoiceRate = this.properties.rateCache[charge.currency]
            }
            // charge.invoiceAmount2 = NumberUtils.roundHalfUp(charge.invoiceRate * charge.amount, 2)
            charge.invoiceAmount2 = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(charge.invoiceRate * charge.amount, this.properties.currency), 2)
          } else {
            charge.invoiceRate = 1
            charge.invoiceAmount2 = charge.amount
          }
          if (charge['entity'] === 'charge') {
            let uuid = '' // 列表父节点的UUID
            if (makeInvoiceMethod === 3) {
              uuid = charge['billingUuid']
            } else if (makeInvoiceMethod === 4) {
              uuid = charge['billingGroupUuid']
            } else if (makeInvoiceMethod === 5) {
              uuid = charge['billingPaymentUuid']
            }
            if (invoiceAmountMap.has(uuid)) {
              // invoiceAmountMap.set(uuid, invoiceAmountMap.get(uuid) + (charge.receivable === this.properties.isAr ? 1 : -1) * charge.invoiceAmount2)
              invoiceAmountMap.set(uuid, RateUtil.getAmountByCurrency(invoiceAmountMap.get(uuid) + (charge.receivable === this.properties.isAr ? 1 : -1) * charge.invoiceAmount2, this.properties.currency))
            } else {
              invoiceAmountMap.set(uuid, (charge.receivable === this.properties.isAr ? 1 : -1) * charge.invoiceAmount2)
            }
          }
          if (charge.currency !== this.properties.currency && this.properties.otherCurrencys.indexOf(charge.currency) === -1) {
            this.properties.otherCurrencys.push(charge.currency)
          }
        }
      }
      this.showCurrency()
    },
    showCurrency() {
      this.properties.txtCurrency1 = ''
      this.properties.txtRate1 = ''
      this.properties.txtCurrency2 = ''
      this.properties.txtRate2 = ''
      //
      if (this.properties.otherCurrencys.length > 0) {
        this.properties.txtCurrency1 = this.properties.otherCurrencys[0]
        this.properties.txtRate1 = this.changeInfinity(this.properties.rateCache[this.properties.txtCurrency1])
      }
      if (this.properties.otherCurrencys.length > 1) {
        this.properties.txtCurrency2 = this.properties.otherCurrencys[1]
        this.properties.txtRate2 = this.changeInfinity(this.properties.rateCache[this.properties.txtCurrency2])
      }
    },
    changeInfinity(value) {
      if (value === Infinity) {
        return ''
      }
      return NumberUtils.formatNumber(value, 8)
    },
    toAdd() {
      // // this.maintainDialog.maintainForm =
      // this.maintainDialog.title = '新增'
      // this.maintainDialog.isEdit = false
      // this.maintainDialog.show = true
      this.isEditing = true
      this.needSave = true
      this.isEditInvoiceGoodsName()
      const row = {}
      // 发票类型
      row.invoiceType = this.properties.invoiceType
      row.goodsNameRMB = ''
      row.goodsNameUSD = ''
      row.goodsNameJPY = ''
      row.goodsNameEUR = ''
      row.taxRate = 0
      row.taxRevenueShortName = ''
      row.taxRevenueName = ''
      // 分公司
      row.officeId = this.$store.getters.currentOfficeId
      this.properties.invoiceGoodsNameList.push(row)
      console.log('toAdd', row)
      this.$nextTick(() => {
        this.gridApi.deselectAll()
        const nodes = this.gridApi.getRenderedNodes()
        const lastNode = nodes[nodes.length - 1]
        lastNode.setSelected(true)
      })
    },
    toEdit() {
      // const self = this
      // getGridSelectedIds(this.gridOptions).then(ids => {
      //   if (ids.length === 0) {
      //     self.$message.error(self.$t('common.tips.hasOneAtleast'))
      //   } else {
      //     // this.maintainDialog.maintainForm = { ...getGridSelected(this.gridOptions)[0] }
      //     this.maintainDialog.title = '修改'
      //     this.maintainDialog.isEdit = true
      //     this.maintainDialog.show = true
      //   }
      // })
      this.isEditing = true
      this.needSave = true
      this.isEditInvoiceGoodsName()
    },
    isEditInvoiceGoodsName() {
      console.log('isEditInvoiceGoodsName', this.isEditing)
      for (const item of this.invoiceGoodsNameColumnDefs) {
        if (item.custom instanceof Object) {
          item.custom.isEdit = this.isEditing
        }
      }
      // 刷新
      this.properties.invoiceGoodsNameList = [...this.properties.invoiceGoodsNameList]
    },
    toDelete() {
      // const self = this
      // getGridSelectedIds(this.invoiceGoodsName.gridOptions).then(ids => {
      //   if (ids.length === 0) {
      //     self.$message.error(self.$t('common.tips.hasOneAtleast'))
      //   } else {
      //     // eslint-disable-next-line no-unused-vars
      //     const rowDataSelected = { ...getGridSelected(this.gridOptions)[0] }
      //     // todo: do delete and close this dialog finally
      //   }
      // })
      const rowDataSelected = getGridSelected(this.invoiceGoodsName.gridOptions)
      if (rowDataSelected.length === 0) {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
        return
      }
      //
      const self = this
      self.$confirm(this.$t('CargoMsg.Cargo_ConfirmCancellationOfRecord'), this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        type: 'warning'
      }).then(() => {
        self.loading = getLoading()
        deleteInvoiceGoodsName(rowDataSelected).then(res => {
          console.log('deleteInvoiceGoodsName', res)
          self.properties.invoiceGoodsNameList = res.data
          //
          this.isEditing = false
          this.needSave = false
          this.isEditInvoiceGoodsName()
        }).finally(() => {
          self.loading.close()
        })
      }).catch(() => {
        //
      })
    },
    // 保存
    toSave() {
      if (this.properties.invoiceGoodsNameList.length > 0) {
        const invoiceGoodsNameList = this.properties.invoiceGoodsNameList
        // 重复维护
        for (const item of invoiceGoodsNameList) {
          if (item.invoiceType === '') {
            this.$message.warning(this.$t('CargoMsg.Cargo_RecordsWithEmptyInvoiceTypeExist'))
            return
          }
          // CARGO-8599，RMB/USD费用项目名称不可以为空
          // StrUtils.isEmpty(item.goodsNameJPY) 日币先不加为空判断，历史数据基本都是空的
          if (StrUtils.isEmpty(item.goodsNameRMB) || StrUtils.isEmpty(item.goodsNameUSD)) {
            this.$message.warning(this.$t('CargoMsg.Cargo_IINMCTBE'))
            return
          }

          let bExist = false
          for (const item2 of invoiceGoodsNameList) {
            if (item.uuid !== item2.uuid && item.invoiceType === item2.invoiceType && item.goodsNameRMB === item2.goodsNameRMB && item.goodsNameUSD === item2.goodsNameUSD && item.goodsNameJPY === item2.goodsNameJPY && item.goodsNameEUR === item2.goodsNameEUR) {
              bExist = true
              break
            }
            // 都是新增的
            if (item.invoiceType === item2.invoiceType && StrUtils.isEmpty(item.uuid) && StrUtils.isEmpty(item2.uuid) && item !== item2 && item.goodsNameRMB === item2.goodsNameRMB && item.goodsNameUSD === item2.goodsNameUSD && item.goodsNameJPY === item2.goodsNameJPY && item.goodsNameEUR === item2.goodsNameEUR) {
              bExist = true
              break
            }
          }
          if (bExist) {
            const stateName = ColumnUtils.invoiceTypeFunc(item.invoiceType)
            this.$message.warning(this.$t('CargoMsg.Cargo_DMROITE').format(stateName))
            return
          }
        }

        this.loading = getLoading()
        saveInvoiceGoodsName(this.properties.invoiceGoodsNameList).then(res => {
          console.log('saveInvoiceGoodsName', res)
          this.properties.invoiceGoodsNameList = res.data
          //
          this.isEditing = false
          this.needSave = false
          this.isEditInvoiceGoodsName()
        }).finally(() => {
          this.loading.close()
        })
      }
    },
    // 设置默认
    doDefaultSetting() {
      if (this.properties.invoiceGoodsNameList.length === 0) return
      const rowDataSelected = getGridSelected(this.invoiceGoodsName.gridOptions)
      if (rowDataSelected.length === 0) return
      const invoiceGoodsName = rowDataSelected[0]
      invoiceGoodsName.defaultGoodsName = true
      console.log('doDefaultSetting', invoiceGoodsName)
      // 相同发票类型
      for (const item of this.properties.invoiceGoodsNameList) {
        if (item.invoiceType === invoiceGoodsName.invoiceType && item.uuid !== invoiceGoodsName.uuid) {
          item.defaultGoodsName = false
        }
      }
      // 保存
      this.toSave()
    },
    onCellChange(params) {
      console.log('onCellChange', params)
      const invoiceGoodsName = params.data
      const field = params.field
      const value = params.value
      //
      const invoiceGoodsNameList = this.properties.invoiceGoodsNameList
      const invoiceItemGoodsName = this.properties.invoiceItemGoodsName
      const defaultGoodsName = this.properties.defaultGoodsName
      switch (field) {
        case 'invoiceType':
          invoiceGoodsName.invoiceType = value
          // 默认值
          // eslint-disable-next-line no-case-declarations
          let bExist = false
          for (const item of invoiceGoodsNameList) {
            if (item.invoiceType === invoiceGoodsName.invoiceType && item.uuid !== invoiceGoodsName.uuid) {
              bExist = true
              break
            }
            // 都是新增的
            if (item.invoiceType === invoiceGoodsName.invoiceType && StrUtils.isEmpty(invoiceGoodsName.uuid) && StrUtils.isEmpty(item.uuid) && item !== invoiceGoodsName) {
              bExist = true
              break
            }
          }
          if (!bExist) {
            invoiceGoodsName.defaultGoodsName = true
            // 0:海运费 1:根据币种计算 2:发票项目根据发票类型转换(增值税普通发票则名称为：国际货代服务费；增值税专用发票则名称为：货运代理费)
            if (invoiceItemGoodsName === 0) {
              invoiceGoodsName.goodsNameRMB = defaultGoodsName
              invoiceGoodsName.goodsNameUSD = defaultGoodsName
              invoiceGoodsName.goodsNameJPY = defaultGoodsName
              invoiceGoodsName.goodsNameEUR = defaultGoodsName
            } else if (invoiceItemGoodsName === 1) {
              invoiceGoodsName.goodsNameRMB = this.$t('Clearing.InternationalFreightForwardingFee')
              invoiceGoodsName.goodsNameUSD = this.$t('Clearing.InternationalShippingFee')
              invoiceGoodsName.goodsNameJPY = this.$t('Clearing.InternationalShippingFee')
              invoiceGoodsName.goodsNameEUR = this.$t('Clearing.InternationalShippingFee')
            } else if (invoiceItemGoodsName === 2) {
              if (invoiceGoodsName.invoiceType === 2) {
                invoiceGoodsName.goodsNameRMB = this.$t('Clearing.InternationalFreightServiceFee')
                invoiceGoodsName.goodsNameUSD = this.$t('Clearing.InternationalFreightServiceFee')
                invoiceGoodsName.goodsNameJPY = this.$t('Clearing.InternationalFreightServiceFee')
                invoiceGoodsName.goodsNameEUR = this.$t('Clearing.InternationalFreightServiceFee')
              } else if (invoiceGoodsName.invoiceType === 3) {
                invoiceGoodsName.goodsNameRMB = this.$t('Clearing.FreightForwardingFee')
                invoiceGoodsName.goodsNameUSD = this.$t('Clearing.FreightForwardingFee')
                invoiceGoodsName.goodsNameJPY = this.$t('Clearing.FreightForwardingFee')
                invoiceGoodsName.goodsNameEUR = this.$t('Clearing.FreightForwardingFee')
              } else {
                invoiceGoodsName.goodsNameRMB = defaultGoodsName
                invoiceGoodsName.goodsNameUSD = defaultGoodsName
                invoiceGoodsName.goodsNameJPY = defaultGoodsName
                invoiceGoodsName.goodsNameEUR = defaultGoodsName
              }
            } else {
              invoiceGoodsName.defaultGoodsName = false
            }
          }
          // 如果有默认 其他也有默认
          if (invoiceGoodsName.defaultDetails) {
            this.defaultDetail(invoiceGoodsNameList, invoiceGoodsName)
          }
          break
        case 'taxRevenueShortName':
          invoiceGoodsName.taxRevenueShortName = value
          break
        case 'taxRevenueName':
          invoiceGoodsName.taxRevenueName = value
          break
        case 'taxRate':
          // 如果有默认 其他也有默认
          if (invoiceGoodsName.defaultDetails) {
            this.defaultDetail(invoiceGoodsNameList, invoiceGoodsName)
          }
          break
        case 'defaultDetails':
          if (params.value) {
            this.defaultDetail(invoiceGoodsNameList, invoiceGoodsName)
          }
          break
        case '':
          break
        default:
      }
      // 刷新
      this.gridApi.refreshCells({ force: true })
      this.$emit('cellChange', params)
    },
    defaultDetail(invoiceGoodsNameList, invoiceGoodsName) {
      for (const item of invoiceGoodsNameList) {
        if (item.invoiceType === invoiceGoodsName.invoiceType && item.taxRate === invoiceGoodsName.taxRate && item.uuid !== invoiceGoodsName.uuid) {
          item.defaultDetails = false
        }
        // 都是新增的
        if (item.invoiceType === invoiceGoodsName.invoiceType && item.taxRate === invoiceGoodsName.taxRate && StrUtils.isEmpty(invoiceGoodsName.uuid) && StrUtils.isEmpty(item.uuid) && item !== invoiceGoodsName) {
          item.defaultDetails = false
        }
      }
    },
    // 选择开票币种
    currencyChangeEvent(value) {
      console.log('currencyChangeEvent:', value)
      this.properties.currency = value.code
      // 重置
      this.properties.isInvoicingByBillingRate = false
    },
    // 选择发票类型
    invoiceTypeChange(value) {
      console.log('invoiceTypeChange:', value)
      // 非增值税发票，默认选择纸质发票
      if (!(value === 2 || value === 3)) {
        this.properties.groupingMakeType = 0
      }
      // 电子发票（增值税专用发票） /  电子发票（普通发票） 默认电子发票
      if (value === InvoiceConstant.INVOICE_TYPE_VAT_FEI.code || value === InvoiceConstant.INVOICE_TYPE_NORMAL_FEI.code) {
        if (!this.properties.specificConstraintType) {
          this.properties.specificConstraintType = '00'
        }
        this.properties.groupingMakeType = 1
      } else {
        this.properties.specificConstraintType = ''
      }
    },
    // 选择结算部门
    settleDepartmentChangeEvent(value) {
      console.log('settleDepartmentChangeEvent:', value)
      if (StrUtils.isEmpty(value.value)) {
        this.properties.settleDepartment = 0
        this.properties.settleDepartmentPrefix = ''
      } else {
        this.properties.settleDepartment = value.value
        this.properties.settleDepartmentPrefix = value.jobNoPrefix
      }
    },
    changeInvoicingByBillingRate() {
      this.properties.isInvoicingByBillingRate = false
    },
    changeInvoiceType() { // 调整发票类型下拉框数据源
      this.isNuoNuo = this.isFei && this.properties.interfaceNameEI === InvoiceConstant.INVOICE_NUONUO
    },
    btnSetupHandler() {
      if (this.commandCode === this.$t('CargoMsg.Cargo_InvoiceChargeItemSetup')) {
        this.invoiceChargeItemDialog.visible = true
      } else if (this.commandCode === this.$t('CargoMsg.Cargo_InvoiceChargeUnitSetup')) {
        this.invoiceChargeUnitDialog.visible = true
      }
    },
    // 应用全部
    applyRuleToAllChangeHandler() {
      this.toNext()
    },
    endTabHandler() {
      this.toNext()
    }
  }
}
</script>
